<smt-modal [(isActive)]="confirmModalActive"  [allowDropDownOverflow]="true" [disableFooter]="false" [disableHeader]="true" 
    (acceptEvent)="removeFacility()" (rejectEvent)="confirmModalActive = false" 
    acceptText="Remove" acceptCssClass="button primary" rejectText="Cancel" rejectCssClass="button cancel">
   <div role="body">
        Please confirm permanent removal of record.
   </div>
</smt-modal>
<div class="page-header-outer">
  <div class="page-header">
      <h1>Facilities</h1>
      <div class="controls">
            <button [disabled]="!addButtonEnabled" (click)="onAddFacilityClick()"><span class="icon-plus"></span> Add New</button>                             
      </div>
  </div>
</div>
<div class="content-inner">
  <div class="admin-list" [ngClass]="{'loading': adminListLoading }"     
        infinite-scroll
        [infiniteScrollDistance]="scrollDistance"
        [infiniteScrollThrottle]="scrollThrottle"
        [fromRoot]="false"
        [scrollWindow]="false"
        [infiniteScrollContainer]="scrollSelector"
        (scrolled)="onScrollDown()">            
      <div class="filter-sort">
          <div class="filter">
              <input class="compact magic-filter" (keyup)="onSearchKey($event)" [(ngModel)]="searchText" name="SearchKey" type="text" placeholder="Search by Name">
          </div>
          <div class="sort">
              <label class="compact">Sort</label>
              <select class="compact" (change)="onSortTypesDropDownChanged($event)" [(ngModel)]="selectedFilter" name="SortList">
                  <option *ngFor='let type of sortTypes' [value]="type" (change)="setSelectedFilter($event)">
                      {{type}}
                  </option>
              </select> 
              <a class="arrow compact" (click)="onChangeSortOrder()" 
                  [ngClass]="sortAscending ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold'"></a>
          </div>
      </div>
      <ul class="adminListScroll" > 
          <li *ngFor="let facility of facilities" [value]="facility.id" (click)="onSelection(facility)" 
              [ngClass]="{'active': selection != undefined && selection != null && facility.id == selection.id } ">
              <ul class="added">
                    <li class="active">
                        <div *ngIf="facility.mostRecent">
                            <span class="icon-plus"></span> New
                        </div>
                    </li>
              </ul>
              <div class="title">{{ facility.name }}</div>
              <ul class="details">
                  <li class="modified">
                            <span class="label">Acronym</span>
                            <span class="value">{{ facility.acronym }}</span>
                  </li>
                  <li class="modified">
                      <span class="label">Last Modified</span>
                      <span class="value">{{ facility.modifiedDate == null ? "&nbsp;" : ( facility.modifiedDate + "Z" | date: 'M/dd/yy h:mm a') }}</span>
                  </li> 
              </ul> 
          </li> 
      </ul>
  </div> 
  <div class="admin-action-window" [ngClass]="{ 'loading': adminActionLoading }"> 
      <div class="admin-action suppress-scroll" id="edit" [ngClass]="{ 'active': showAdminActionWindow }" *ngIf="selection">
          <div class="header">
              <div class="title">
                  {{ adminActionLabelText }}
                  <button class="primary compact" [disabled]="!deleteButtonEnabled" (click)="confirmModalActive = true"><span class="icon-trash btn-Icon"></span>{{ adminActionButton1LabelText }}</button>   	
                  <a class="close" href="javascript:void(0)" (click)="onCancel()"><span class="icon-cross"></span></a>
              </div>
          </div>
          <div>
              <form #facilityEditForm="ngForm" (ngSubmit)="onSave()">
                  <section>
                    <div class="body">
                        <div class="form-group">
                            <label>Name</label>
                            <input maxlength="25" type="text" required name="Name" [readonly]="readOnly" [(ngModel)]="selectedName">
                        </div>
                        <div class="form-group">
                            <label>Acronym</label>
                            <input maxlength="25" type="text" required name="Acronym" [readonly]="readOnly" [(ngModel)]="selectedAcronym">
                        </div>
                        <div class="form-group">
                            <label>Pay Period Start Date</label>
                            <input type="date" required name="payPeriodStartDate" [readonly]="readOnly" [(ngModel)]="selectedPayPeriodStartDate">
                        </div>
                        <div class="form-group" >
                            <label>Time Zones</label> 
                            <select required name="timeZoneSelect" [(ngModel)]="selectedTimeZoneId" [disabled]="hasWorkflowData">
                                <option *ngFor="let timeZone of timeZones" [value]="timeZone.id">(GMT{{ timeZone.offset }}) {{ timeZone.description }}</option>                  
                            </select>
                        </div>                        
                      </div>
                      <div class="footer">
                          <div>
                              <label class="errormsg">{{ getErrorMessage() }}</label> 
                          </div>
                          <button class="primary" type="submit" [disabled]="!facilityEditForm.form.valid || !facilityEditForm.dirty || !saveButtonEnabled">
                              <span class="icon-plus"></span> Save</button>
                          <button class="cancel" type="button" (click)="onCancel()" [disabled]="saveLoading">
                              <span class="icon-cancel"></span> Cancel</button>
                      </div>
                  </section>
              </form>
          </div>      
      </div>
  </div>
</div>
